import { render, staticRenderFns } from "./RevisaoInterna.vue?vue&type=template&id=30dda3ce&scoped=true"
import script from "./RevisaoInterna.vue?vue&type=script&lang=js"
export * from "./RevisaoInterna.vue?vue&type=script&lang=js"
import style0 from "./RevisaoInterna.vue?vue&type=style&index=0&id=30dda3ce&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dda3ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30dda3ce')) {
      api.createRecord('30dda3ce', component.options)
    } else {
      api.reload('30dda3ce', component.options)
    }
    module.hot.accept("./RevisaoInterna.vue?vue&type=template&id=30dda3ce&scoped=true", function () {
      api.rerender('30dda3ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RevisaoInterna.vue"
export default component.exports